import React from "react";
import { PageHeader } from "@/components/Common";
import MessagesPanel from "@/components/MessagesPanel";
import { useAuth } from "@/contexts/AuthContext";

export default function Messages() {
  const { user } = useAuth();
  return (
    <div className="p-8 space-y-6">
      <PageHeader
        eyebrow="/// Messages"
        title="Team messages"
        subtitle="Direct chat with drivers and mechanics — supports photos, unread badges, live delivery, and role filters."
      />
      {user?.id && <MessagesPanel currentUserId={user.id} />}
    </div>
  );
}
